import React, { useState } from 'react';
import { createDataTable } from '@/components/DataTable';
import { SortDirection } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { getReceivedEmails, ReceivedEmailLogItem } from '@/services/communicore';
import { Button } from '@ygtechnologies/rubus-ui';
import { DateTimeDisplay, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import ReceivedEmailDetailsModal from './ReceivedEmailDetailsModal';
import { formatProject } from './shared';

const DataTable = createDataTable<ReceivedEmailLogItem>();

const ReceivedEmailsTable: React.FC = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('receivedAt', SortDirection.Descending, 25));
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [data, , , isLoading] = useAsyncStateWithIsLoading(() => getReceivedEmails(tableState), [tableState], null);

    if (!data) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <DataTable
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                className="table style-3">
                <DataTable.Column
                    header="Received"
                    field="receivedAt"
                    renderer={(x) => <DateTimeDisplay value={x.value} />}
                />
                <DataTable.Column header="From" field="from" renderer={(x) => x.value.join(', ')} />
                <DataTable.Column header="To" field="to" renderer={(x) => x.value.join(', ')} />
                <DataTable.Column header="Subject" field="subject" />
                <DataTable.Column
                    header="Project"
                    field="projectId"
                    renderer={({ row }) => formatProject(row.projectName, row.projectId)}
                />
                <DataTable.Column header="Type" field="type" />
                <DataTable.Column header="Status" field="status" />
                <DataTable.Column header="Attachments" field="attachmentCount" />
                <DataTable.Column
                    header=""
                    field="id"
                    renderer={({ row }) => (
                        <Button size="xs" variant="tertiary" onClick={() => setSelectedId(row.id)}>
                            Details
                        </Button>
                    )}
                />
            </DataTable>
            {selectedId && <ReceivedEmailDetailsModal id={selectedId} onClose={() => setSelectedId(null)} />}
        </div>
    );
};

export default ReceivedEmailsTable;
